<template>
  <div class="main" v-show="ready">
    <template v-if="cartList.length > 0">
      <!-- 有数据 -->
      <div class="cart-head">
        <a
          href="javascript:;"
          class="action-btn"
          v-if="mode == 'buy'"
          @click="setMode('delete')"
          >管理</a
        >
        <a
          href="javascript:;"
          class="action-btn"
          v-if="mode == 'delete'"
          @click="setMode('buy')"
          >完成</a
        >
        <div calss="sum">
          共
          <span class="num">{{ cartList.length }}</span
          >件商品
        </div>
      </div>
      <!--购物车列表-->
      <div class="cart-list">
        <CartItem
          v-for="c in cartList"
          :key="c.cartId"
          :cart="c"
          @selectedChange="cartSelectedChange"
          @amountChange="cartAmountChange"
        />
      </div>
      <!--购物车底栏-->
      <div class="cart-foot">
        <div class="right">
          <span class="sum" v-show="mode == 'buy'"
            >合计： <span class="num">{{ sum }}</span> {{ ui.pointUnit }}</span
          >
          <a
            href="javascript:;"
            class="action-btn m-button"
            v-if="mode == 'buy'"
            @click="pay"
            >结算({{ buyList.length }})</a
          >
          <a
            href="javascript:;"
            class="action-btn m-button"
            v-if="mode == 'delete'"
            @click="doDelete"
            >删除({{ buyList.length }})</a
          >
        </div>
        <div class="left">
          <CheckboxButton ref="selectAllBtn" @onChange="selectAll" /> 全选
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="easyUser">
        <!-- 无数据 -->
        <EmptyListTip
          :icon="ui.iconEmptyCart"
          text="购物车空空如也~"
          primaryButton="去商城逛逛"
          primaryButtonLink="/pages/homepage/index"
        />
      </template>
      <template v-else>
        <!-- 无数据 -->
        <EmptyListTip
          :icon="ui.iconEmptyCart"
          text="购物车空空如也~"
          primaryButton="去商城逛逛"
          primaryButtonLink="/pages/homepage/index"
          secondButton="看看我能兑换的"
          secondButtonLink="/pages/products/List?affordable=1"
        />
      </template>
    </template>
    <TabBar active="cart"></TabBar>

    <bindPhoneDialog :visible.sync="visibleBindPhone"></bindPhoneDialog>
  </div>
</template>

<script>
import api from "../../api";
import store from "../../api/store";
import CartItem from "@/components/orders/CartItem";
const iconEmptyCart = require("../../assets/icon-empty-cart.png");
// 绑定手机号
import bindPhoneDialog from "@/components/bindPhone/bindPhoneDialog";

var cartAmountTimer;

export default {
  title: "购物车",
  bodyClass: "white-bg",
  components: { CartItem, bindPhoneDialog },
  data() {
    return {
      // 绑定手机号
      visibleBindPhone: false,

      easyUser: store.loginedUser.easyUser,
      ui: {
        iconEmptyCart,
        pointUnit: store.loginedUser.config.pointName,
      },
      ready: false,
      mode: "buy", //可选 buy、delete
      total: 20,
      cartList: [
        // {
        //     product: {
        //         productId: 0,
        //         name: '好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品',
        //         image: 'https://img10.360buyimg.com/mobilecms/s250x250_jfs/t22234/32/1947155483/115874/16bfee6c/5b3df187N78aa7a78.jpg',
        //         skuName: '高级',
        //         price: 2000
        //     },
        //     amount: 10,
        //     isSelected: false
        // }
      ],
    };
  },
  methods: {
    loadData() {
      this.ready = false;
      this.cartList = [];
      api.cart.getCartList(
        (data) => {
          data.shopcarts.forEach((c) => {
            this.cartList.push({
              product: {
                productId: c.sku.skuId,
                name: c.sku.name,
                image: c.sku.image,
                skuName: c.sku.title,
                price: c.sku.price,
              },
              steps: [],
              amount: c.count,
              isSelected: false,
              valid: true,
            });
          });
          this.ready = true;
        },
        (r) => {
          this.$alertDialog(r.msg);
        }
      );
    },
    cartSelectedChange(cart, isSelect) {
      cart.isSelected = isSelect;
    },
    cartAmountChange(cart, amount) {
      cart.amount = amount;
      clearTimeout(cartAmountTimer);
      cartAmountTimer = setTimeout(() => {
        api.cart.addCart(cart.product.productId, amount, true);
      }, 100);
    },
    setMode(mode) {
      this.mode = mode;
      this.selectAll(false);
      this.$refs.selectAllBtn.clearSelected();
    },
    selectAll(isSelectAll) {
      this.cartList.forEach((c) => {
        c.isSelected = isSelectAll;
      });
    },
    doDelete() {
      //1.收集选择的条目
      var ids = [];
      this.cartList.forEach((c) => {
        if (c.isSelected) {
          ids.push(c.product.productId);
        }
      });

      if (ids.length <= 0) {
        //没选择
        return;
      }

      //2.执行删除
      this.$confirmDialog("确认删除？", (btn) => {
        if (btn == "确定") {
          api.cart.removeCart(
            ids.join(","),
            () => {
              this.$toast("已删除");
              this.loadData();
            },
            (r) => {
              this.$alertDialog(r.msg);
            }
          );
        }
      });
    },
    pay() {
      // 手机号绑定
      api.user.getPersonalInfo((user) => {
        store.loginedUser = user;
      });
      if (store.loginedUser.mustBindPhone && !store.loginedUser.phone)
        return (this.visibleBindPhone = true);

      //1.收集选择的条目
      var list = [];
      this.cartList.forEach((c) => {
        if (c.isSelected) {
          list.push(c.product.productId + "-" + c.amount);
        }
      });
      if (list.length <= 0) {
        this.$toast("请选择商品");
        return;
      }
      //2. 前往结算
      this.$routerPush(this, "/pages/payment/payment?cart=" + list.join(","));
    },
  },
  computed: {
    buyList() {
      var list = [];
      this.cartList.forEach((c) => {
        if (c.isSelected) {
          list.push(c);
        }
      });
      return list;
    },
    sum() {
      var total = 0;
      this.cartList.forEach((c) => {
        if (c.isSelected) {
          total += c.amount * c.product.price;
        }
      });
      return total;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped lang="less">
.main {
  min-height: 100vh;
  overflow: auto;
}

.cart-head {
  line-height: 11.73vw;
  width: 100vw;
  border-bottom: 1px solid #e6e6e6;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;

  padding: 0 4vw;
  background: #fff;
  opacity: 0.9;
  box-sizing: border-box;
  font-size: 2.93vw;

  .sum {
    color: #666;
    font-size: 4vw;
  }

  .num {
    color: @themeColor;
    padding: 0 0.3em;
  }

  .action-btn {
    display: block;
    float: right;
  }
}

.cart-list {
  padding-top: 11.73vw;
  padding-bottom: 27.06vw;
}

.cart-foot {
  position: fixed;
  z-index: 11;
  bottom: 13.733vw;
  left: 0;
  right: 0;
  height: 13.33vw;
  .main {
    max-height: 100vh;
    overflow: auto;
  }
  line-height: 13.33vw;
  border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;
  background: #fff;
  font-size: 3.46vw;

  .left {
    padding-left: 4vw;
    color: #666;
  }

  .right {
    float: right;
    color: #000;
    font-size: 0;
    padding-right: 28vw;

    .sum {
      font-size: 3.46vw;
      text-align: right;
      .num {
        color: @themeColor;
        padding: 0 0.3em;
      }
    }

    .action-btn {
      display: inline-block;
      background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
      color: #fff;
      width: 27.6vw;
      text-align: center;
      font-size: 3.46vw;
      border: 0;
      margin: 0;
      padding: 0;
      position: absolute;
      z-index: 12;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/Cart.vue